import { useFeature } from '../../hooks/isFeatureEnabled';
import { LIGHTNING_FAST_VIPPS_PAYMENT_V2 } from '../../../constants/features/constants';
import { useSelector } from 'react-redux';
import { getPublishedRewardsForProject } from '../../../project/projects-reducer';
import { eligibleForLightningFastVippsPayment } from '../../../project/project-model';
import { trackFeatureFlagCalledEventInPostHog } from '../../../support-and-tracking/analytics-actions';
import { useEffect } from 'react';

export const useVippsLightningFastPayment = ({ project }) => {
    const lightningFastVippsPaymentVariant = useFeature(LIGHTNING_FAST_VIPPS_PAYMENT_V2);
    const projectRewards = useSelector((state) => getPublishedRewardsForProject(state, project?.id));
    const isEligibleForLightningFastVippsPaymentVariant = eligibleForLightningFastVippsPayment({
        project,
        projectRewards,
    });

    const shouldIncludeInVippsLightningFastPaymentTest =
        isEligibleForLightningFastVippsPaymentVariant && lightningFastVippsPaymentVariant;

    useEffect(() => {
        if (shouldIncludeInVippsLightningFastPaymentTest) {
            trackFeatureFlagCalledEventInPostHog(LIGHTNING_FAST_VIPPS_PAYMENT_V2, lightningFastVippsPaymentVariant);
        }
    }, [shouldIncludeInVippsLightningFastPaymentTest, lightningFastVippsPaymentVariant]);

    return {
        shouldShowLightningFastVippsPaymentButton:
            lightningFastVippsPaymentVariant === 'test' && shouldIncludeInVippsLightningFastPaymentTest,
        shouldIncludeInVippsLightningFastPaymentTest,
    };
};
